import type { RequestQuery, ResponseData } from '@vrplatform/data';

export const DEFAULT_RECURRING_FEE_FILTER_LIMIT = 50;

export type RecurringFeeType = NonNullable<
  ResponseData<'get:/recurring-fees'>['data'][number]['type']
>;

const RECURRING_FEE_TITLE_BY_TYPE: Record<RecurringFeeType, string> = {
  bookingChannelFee: 'Booking Channel Fee',
  cleaningFee: 'Cleaning Fee',
  merchantFee: 'Merchant Fee',
  managementFee: 'Management Commission',
  additionalFee: 'Other Fee',
};

export function getRecurringFeeFilterQuery({
  page,
  search,
  includeInactive,
  type,
}: {
  page: number;
  search?: string;
  includeInactive: boolean;
  type?: RecurringFeeType | null;
}): RequestQuery<'get:/recurring-fees'> {
  return {
    limit: DEFAULT_RECURRING_FEE_FILTER_LIMIT,
    page,
    search: search?.trim() || undefined,
    status: includeInactive ? undefined : 'active',
    type: type ?? undefined,
  };
}

export function getRecurringFeeGroup(
  type: RecurringFeeType | null | undefined
) {
  return RECURRING_FEE_TITLE_BY_TYPE[type ?? 'additionalFee'];
}

export function getRecurringFeeTitle(name: string | null | undefined) {
  return name?.trim() || 'No name';
}
